<dsd-modal
  id="modale-annuler"
  [buttonPrimaryLabel]="'modalAnnuler.annuler' | translate"
  [buttonSecondaryLabel]="'modalAnnuler.continuer' | translate"
  [show]="showValue"
  aria-labelledby="modale-annuler"
  (dsdModalSecondaryClick)="showDialog()"
  (dsdModalPrimaryClick)="redirectionAccueil()"
>
  <h2 slot="title">{{ 'modalAnnuler.titre' | translate }}</h2>
  <p>{{ 'modalAnnuler.label' | translate }}</p>
</dsd-modal>
